import React, { useCallback, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { serviceGetProgramReward } from "../../../../../services/Reward.service";

const useProductRewardTable = ({ renderRewardList }) => {
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  const [editData, setEditData] = useState(null);
  const [totalShow, setTotalShow] = useState(10);
  const [isFetching, setIsFetching] = useState(false);
  const [isDialog, setIsDialog] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      serviceGetProgramReward({
        program_id: id,
        index: 1,
      }).then((res) => {
        if (!res.error) {
          const resData = res?.data;
          setAllData(resData);
          setData(resData);
        }
      });
    }
  }, [id, renderRewardList]);

  const toggleDialog = useCallback(
    (data) => {
      setIsDialog((e) => !e);
      if (data?.id) {
        setEditData(data);
      } else {
        setEditData(null);
      }
    },
    [editData, isDialog]
  );

  useEffect(() => {
    // initData();
    _processData();
  }, [currentPage, data]);

  const _processData = () => {
    const from = currentPage * totalShow - totalShow;
    let to = currentPage * totalShow;
    if (from <= data.length) {
      to = to <= data.length ? to : data.length;
      setCurrentData(data.slice(from, to));
    }
  };

  const handlePageChange = useCallback(
    (type) => {
      console.log("_handlePageChange", type);
      if (Math.ceil(data.length / totalShow) >= type + 1) {
        setCurrentPage(type + 1);
        _processData();
      }
    },
    [_processData, setCurrentPage, data, totalShow]
  );

  const handleSortOrderChange = useCallback((row, order) => {
    console.log(`handleSortOrderChange key:${row} order: ${order}`);
  }, []);

  const handleRowSize = (page) => {
    console.log(page);
  };

  return {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    data,
    currentData,
    currentPage,
    isFetching,
    isDialog,
    toggleDialog,
    editData
  };
};

export default useProductRewardTable;
